import { User } from '@/types'
import { connect, WindowMessenger, Methods } from 'penpal'

export interface ExportApiContext extends Methods {
    authorizeUser: () => Promise<User | null>
    getUser: () => Promise<User | null>
    chargeUser: (amount: number) => Promise<User | null>
}

const createApiMethods = (ctx: ExportApiContext) => ({
    authorizeUser() {
        return ctx.authorizeUser()
    },
    getUser() {
        return ctx.getUser()
    },
    chargeUser(amount: number) {
        return ctx.chargeUser(amount)
    },
})

export type ExportApi = ReturnType<typeof createApiMethods>

export const initExportApi = async (iframe: HTMLIFrameElement, ctx: ExportApiContext) => {
    if (!iframe.contentWindow) {
        throw new Error('Iframe did not load yet')
    }
    const messenger = new WindowMessenger({
        remoteWindow: iframe.contentWindow,
    })
    const { promise, destroy } = connect({
        messenger,
        methods: createApiMethods(ctx),
    })
    await promise

    return destroy
}

export type DestroyExportApiFunction = ReturnType<typeof connect>['destroy']

export const createExportApiClient = async () => {
    const messenger = new WindowMessenger({
        remoteWindow: window.parent,
    })
    const { promise, destroy } = await connect<ExportApiContext>({ messenger })
    const client = await promise

    return { client, destroy }
}
